import React, { Component } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import styled from "styled-components";
import { InputEl } from "src/react/forms/styles";
import { color } from "src/styles/variables";

export class PasswordInput extends Component {
  state = {
    passwordInputType: "password",
  };

  showHidePassword = () => {
    this.setState((previousState) => ({
      isPasswordVisible: !previousState.isPasswordVisible,
    }));
  };

  render() {
    const { isPasswordVisible } = this.state;
    return (
      <PasswordInputWrapper>
        <InputEl
          {...this.props}
          hideIsValidIcon
          type={isPasswordVisible ? "input" : "password"}
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
        />

        <PasswordToggler type="button" onClick={this.showHidePassword}>
          {isPasswordVisible ? (
            <PasswordEyeImageClosed />
          ) : (
            <PasswordEyeImage />
          )}
        </PasswordToggler>
      </PasswordInputWrapper>
    );
  }
}

const PasswordInputWrapper = styled.div`
  position: relative;
`;
const PasswordToggler = styled.button`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  background: none;
  border: 0;
  padding: 0;
`;
PasswordToggler.displayName = "PasswordToggler";

const PasswordEyeImage = styled(FaEye)`
  color: ${color.darkGrey};
  height: 18px;
  width: 18px;
`;
const PasswordEyeImageClosed = styled(FaEyeSlash)`
  color: ${color.darkGrey};
  height: 18px;
  width: 18px;
`;
